import variables from 'styles/shared/variables.scss';

export enum PROFILE_STATUS {
  DRAFT = 'Draft',
  APPROVED = 'Approved',
  DECLINED = 'Declined',
  INPROCESS = 'InProcess',
  UPDATEREQUIRED = 'UpdateRequired',
  URGENTUPDATE = 'UrgentUpdate',
  DUPLICATED = 'Duplicated',
}

export enum PSP_OPERATIONS {
  DEPOSIT = 'Deposit',
  WITHDRAWAL = 'Withdrawal',
  ALL = 'All',
}

export enum PSP_OPERATION_STATUS {
  INPROGRESS = 'InProgress',
  FAILED = 'Failed',
  COMPLETED = 'Completed',
  PENDING = 'Pending',
  CANCELLED = 'Cancelled',
  ONHOLD = 'OnHold',
  TIMEOUT = 'TimeOut',
}

export enum PSP_OPERATIONS_CATEGORIES {
  LOCAL_DEPOSIT = 'LocalDeposit',
}

export enum PSP_OPERATION_FILE_ITEM_TYPE {
  DEPOSIT_BANK_STATEMENT = 'DepositBankStatement',
  DEPOSIT_DIGITAL_WALLET_STATEMENT = 'DigitalWallet',
  CARD_STATEMENT = 'Card',
  DEPOSIT_BANK_PAYSLIP = 'DepositBankPayslip',
  LOCAL_DEPOSIT_BANK_STATEMENT = 'LocalDepositBankStatement',
  LOCAL_DEPOSIT_BANK_TRANSFER = 'LocalDepositBankTransfer',
  LOCAL_DEPOSIT_BANK_DOCUMENTS = 'LocalDepositBankDocuments',
  WIRE_TRANSFER_BANK_DOCUMENTS = 'WireTransferBankDocuments',
  PROOF_ACCOUNT = 'ProofAccount',
  PROOF_TRANSACTION = 'ProofTransaction',
  CRYPTO_WALLET_PROOF_WALLET = 'CryptoWalletProofWallet',
  CRYPTO_WALLET_PROOF_ADDRESS = 'CryptoWalletProofAddress',
}

export enum DEPOSIT_ADMIN_ACTION {
  NONE = 'None',
  PRE_AUTHORIZED = 'PreAuthorized',
  POST_TRANSACTION = 'PostTransaction',
}

export enum BANNER_FILE_TYPE {
  REGULAR = 'Regular',
  POPUP = 'PopUp',
}

export enum BANNER_SIZE {
  SMALL = 'Small',
  MIDDLE = 'Middle',
  FULL_WIDTH = 'FullWidth',
}

export enum BANNER_TEXT_STYLE {
  BOLD = 'Bold',
  UNDERLINE = 'Underline',
  ITALIC = 'Italic',
}

export enum PSP_WIZARD_STEP {
  ACCOUNT_STATEMENT_FORM = 'AccountCreateForm',
  FORM = 'form',
  CONFIRM = 'confirm',
  RESULT = 'result',
  ALIAS_CREATE_FORM = 'aliasCreateForm',
  ALIAS_ATTACH_FORM = 'aliasAttachForm',
}

export enum WALLET_ACCOUNT_TYPE {
  REGULAR = 'Regular',
  TRANSIT = 'Transit',
  ALL = 'All',
}

export enum TRADING_ACCOUNT_TYPE {
  DEMO = 'Demo',
  REAL = 'Real',
}

export enum TRADING_PLATFORM_TYPE {
  META4 = 'Meta4',
  META5 = 'Meta5',
  GMI = 'Gmi',
}

export enum TRADING_PLATFORM_SECTION_TYPE {
  PLATFORMS = 'Platforms',
  TOOLS = 'Tools',
}

export enum EXECUTION_TYPE {
  MANUALLY = 'Manually',
  AUTOMATIC = 'Automatic',
}

export enum WALLET_OPERATION_TRANSFER_TYPE {
  MANUAL_ADJUSTMENT = 'ManualAdjustment',
}

export enum Q_FORM_STATUS {
  DRAFT = 'Draft',
  APPROVED = 'Approved',
  DECLINED = 'Declined',
  INPROCESS = 'InProcess',
  NEW = 'New',
  TERMINATION_IN_PROGRESS = 'TerminationInProgress',
  COMPLETED = 'Completed',
}

export enum ROLES {
  ADMIN = 'Admin',
  USER = 'User',
}

export enum DOCUMENT_STATUS {
  TO_VERIFY = 'ToVerify',
  APPROVED = 'Approve',
  REJECTED = 'Reject',
  IN_PROCESS = 'InProcess',
}

export enum DOCUMENT_TYPE {
  NATIONAL_ID = 'NationalId',
  PASSPORT = 'Passport',
  DRIVING_LICENSE = 'DrivingLicense',
  UTILITY_BILL = 'UtilityBill',
  BANK_CARD = 'BankCard',
}

export enum DOCUMENT_SUB_TYPE {
  FRONT_SIDE = 'FrontSide',
  BACK_SIDE = 'BackSide',
}

export enum FILE_TYPE {
  IMAGE = 'Image',
  PDF = 'Pdf',
  UNKNOWN = 'Unknown',
}

export enum ISSUE_STATUS {
  OPEN = 'Open',
  IN_PROGRESS = 'InProgress',
  RESOLVED = 'Resolved',
}

export enum ITEM_TYPE {
  USER = 'User',
  QFORM = 'QForm',
  TRADING_ACCOUNT = 'TradingAccount',
  USER_DOCUMENT = 'UserDocument',
  ISSUE = 'Issue',
  COMPONENT = 'Component',
  NOTIFICATION_TEMPLATE = 'NotificationTemplate',
  PSP_OPERATION = 'PspOperation',
  EXTERNAL_JOB = 'ExternalJob',
  TRADING_ACCOUNT_TYPE = 'TradingAccountType',
  TRADING_ACCOUNT_TYPE_CATEGORY = 'TradingAccountTypeCategory',
  TRADING_GROUP = 'TradingGroup',
  SALES_USER = 'SalesUser',
  BUSINESS_MANAGER = 'BusinessManager',
  USER_BANK_ACCOUNT = 'UserBankAccount',
  USER_DIGITAL_WALLET_ACCOUNT = 'UserDigitalWalletAccount',
  USER_CARD_ACCOUNT = 'UserCard',
  SHORT_LINK = 'ShortLink',
  BANNER_CONFIGURATION = 'BannerConfiguration',
  MAM_MASTER_ACCOUNT = 'MamMasterAccount',
  GROUP = 'Group',
  AUTO_ASSIGNMENT_RULE = 'AutoAssignmentRule',
  URL_DOMAIN = 'UrlDomain',
  ONBOARDING_CONFIGURATION = 'OnboardingConfiguration',
  NOTIFICATION_GROUP = 'NotificationGroup',
  TRADING_BONUS_LINK = 'TradingBonusLink',
  KYT_VERIFICATION = 'KytVerification',
  KYT_VERIFICATION_OPERATION = 'KytVerificationOperation',
  KYT_VERIFICATION_WITHDRAWAL_ATTEMPT = 'KytVerificationWithdrawalAttempt',
  TRADING_SYMBOL = 'TradingSymbol',
  META_SERVER = 'MetaServer',
  USER_NAME_ALIAS = 'UserNameAlias',
  VIDEO_CONFIGURATION = 'VideoConfiguration',
  CUSTOM_NOTIFICATION = 'CustomNotification',
  CUSTOM_PUSH_NOTIFICATION = 'CustomPushNotification',
  COMPANY_ACCOUNT = 'CompanyAccount',
  COMPANY_TRANSFER = 'CompanyTransfer',
  CONTEST = 'Contest',
  LOYALTY_PROGRAM = 'LoyaltyProgram',
  LEGAL_DOCUMENT = 'LegalDocument',
  EMAIL_TEMPLATE = 'EmailTemplate',
  PAYMENT_SYSTEM_CONSENT = 'PaymentSystemConsent',
  TRUSTED_DEVICE = 'TrustedDevice',
  DATA_CHANGE_REQUEST = 'DataChangeRequest',
  BANK = 'Bank',
  DIGITAL_WALLET = 'DigitalWallet',
  TRADING_PLATFORM_BRANDING_SETTINGS = 'TradingPlatformBrandingSettings',
  LOYALTY_PROGRAM_REDEEM = 'LoyaltyProgramRedeem',
  NOTIFICATION_CATEGORY = 'NotificationCategory',
  IMPORT_ITEM = 'ImportItem',
  FAQ = 'Faq',
  CLIENT_SIDE_TRANSLATION = 'ClientSideTranslation',
  DOCUMENT_CONFIGURATION = 'DocumentConfiguration',
  LEGAL_TRADING_PLATFORM = 'LegalTradingPlatform',
  MARKETING_BANNER_CATEGORY = 'MarketingBannerCategory',
  CUSTOM_TAG = 'CustomTag',
}

export enum ACTION_TYPE {
  NOTE = 'Note',
}

export enum GROUP_MAPPING {
  REAL_MAM_MASTER = 'RealMamMaster',
  REAL_MAM_MASTER_ECN = 'RealMamMasterEcn',
  REAL_MAM_INVESTOR = 'RealMamInvestor',
  REAL_PARTNER = 'RealPartner',
}

export enum JOB_STATUS {
  INIT = 'Init',
  PENDING = 'Pending',
  START = 'Start',
  IN_PROGRESS = 'InProgress',
  COMPLETED = 'Completed',
  CANCELED = 'Canceled',
  FAILED = 'Failed',
}

export enum UNIT {
  USD = 'Usd',
  PIPS = 'Pips',
  PERCENTAGE = 'Percentage',
}

export enum KNOWN_INTERFACE {
  BONUS_PROGRAM = 'IBonusProgram',
  BONUS_REDUCTION = 'IBonusReduction',
  INACTIVE_ACCOUNT_BONUS = 'IInactiveAccountBonus',
  QFORM = 'IQForm',
  PSP = 'IPsp',
  RECURRING_JOB = 'IRecurringJob',
  IB_SPECIFICATION = 'IIbSpecification',
  JURISDICTION = 'IJurisdiction',
  MAIL_SENDER = 'IMailSender',
  SMS_SENDER = 'ISmsSender',
  PUSH_SENDER = 'IPushSender',
  KYC_PROVIDER = 'IKycProvider',
  KYT_PROVIDER = 'IKytProvider',
  SYSTEM_SETTINGS = 'ISystemSettings',
  AUTO_WITHDRAWALS_RULE = 'IAutoWithdrawalsRule',
  TRADING_ACCOUNT_ARCHIVING_RULE = 'ITradingAccountArchivingRule',
  BDM_ASSIGNMENT_RULE = 'IBDMAssignmentRule',
}

export enum Q_FORM_TYPE {
  IB = 'IIbQForm',
  USER = 'IUserQForm',
  MARKUP = 'IMarkupQForm',
  MAM_MASTER = 'IMAMMasterQForm',
  MAM_INVESTOR = 'IMAMInvestorQForm',
  MAM_MASTER_WITH_LPOA = 'IMAMMasterWithLPOAQForm',
}

export enum PAYMENT_SUMMARY_TYPE {
  CATEGORY = 'Category',
  PAYMENT_SYSTEM = 'PaymentSystem',
}

export enum LEGAL_SECTION_TYPE {
  LEGAL = 'Legal',
}

export enum CLIENT_SOURCE_TYPE {
  DIRECT = 'Direct',
  IB_TREE = 'IbTree',
}

export enum TRANSFER_ACCOUNT_TYPE {
  WALLET = 'wallet',
  ACCOUNT = 'account',
}

export enum DOCUMENT_CATEGORY {
  CategoryA = 'CategoryA',
  CategoryB = 'CategoryB',
}

export enum USER_DOCUMENT_TYPE {
  Individual = 'Individual',
}

export enum USER_STATEMENT_ACCOUNT_STATUS {
  CREATED = 'Created',
  VERIFIED = 'Verified',
  REJECTED = 'Rejected',
  ACTION_REQUIRED = 'ActionRequired',
}

export enum SHORT_LINK_TYPE {
  UNKNOWN = 'Unknown',
  IB_INVITATION = 'IbInvitation',
  SALES_INVITATION = 'SalesInvitation',
  ADV_CAMPAIGN = 'AdvCampaign',
}

export enum SHORT_LINK_VERSION {
  VERSION_1 = 'Version_1',
  VERSION_2 = 'Version_2',
}

export enum MAM_MASTER_ACCOUNT_STATUS {
  DRAFT = 'Draft',
  IN_PROGRESS = 'InProgress',
  DECLINED = 'Declined',
  APPROVED = 'Approved',
}

export enum SHORT_LINK_STATUS {
  DRAFT = 'Draft',
  IN_PROCESS = 'InProcess',
  DECLINED = 'Declined',
  APPROVED = 'Approved',
  EXPIRED = 'Expired',
}

export enum ENUM_LANGUAGE_CODE {
  en = 'en',
  ru = 'ru',
  zh = 'zh',
  ms = 'ms',
  th = 'th',
  id = 'id',
  vi = 'vi',
  es = 'es',
  ar = 'ar',
  pt = 'pt',
}

export enum ENUM_LOCALE_CODE {
  enUS = 'en-US',
  ru = 'ru',
  zhCN = 'zh-CN',
  msMY = 'ms-MY',
  thTH = 'th-TH',
  idID = 'id-ID',
  viVN = 'vi-VN',
  esES = 'es-ES',
  ar = 'ar',
  ptPT = 'pt-PT',
}

export enum ENUM_LOCALE_CODE_UPPER {
  enUS = 'EN_US',
  ru = 'RU',
  zhCN = 'ZH_CN',
  msMY = 'MS_MY',
  thTH = 'TH-TH',
  idID = 'IS_ID',
  viVN = 'VI_VN',
  esES = 'ES_ES',
  ar = 'AR',
  ptPT = 'PT_PT',
}

export const LANGUAGE_CODE_TO_LOCALE_CODE = {
  [ENUM_LANGUAGE_CODE.en]: ENUM_LOCALE_CODE.enUS,
  [ENUM_LANGUAGE_CODE.ru]: ENUM_LOCALE_CODE.ru,
  [ENUM_LANGUAGE_CODE.zh]: ENUM_LOCALE_CODE.zhCN,
  [ENUM_LANGUAGE_CODE.ms]: ENUM_LOCALE_CODE.msMY,
  [ENUM_LANGUAGE_CODE.th]: ENUM_LOCALE_CODE.thTH,
  [ENUM_LANGUAGE_CODE.id]: ENUM_LOCALE_CODE.idID,
  [ENUM_LANGUAGE_CODE.vi]: ENUM_LOCALE_CODE.viVN,
  [ENUM_LANGUAGE_CODE.es]: ENUM_LOCALE_CODE.esES,
  [ENUM_LANGUAGE_CODE.ar]: ENUM_LOCALE_CODE.ar,
  [ENUM_LANGUAGE_CODE.pt]: ENUM_LOCALE_CODE.ptPT,
};

export type TYPE_LANGUAGE_CODE_TO_LOCALE_CODE = typeof LANGUAGE_CODE_TO_LOCALE_CODE;

export enum CURRENCY {
  USD = 'USD',
  EUR = 'EUR',
  IDR = 'IDR',
  RMB = 'RMB',
  CNY = 'CNY',
  CNH = 'CNH',
  MYR = 'MYR',
  GBP = 'GBP',
  THB = 'THB',
  VND = 'VND',
  BND = 'BND',
  BTC = 'BTC',
  USC = 'USC',
  USDT = 'USDT',
  PHP = 'PHP',
  ZAR = 'ZAR',
}

export enum LEGAL_TYPE {
  CLIENT_AGREEMENT = 'ClientAgreement',
  PRIVACY_POLICY = 'PrivacyPolicy',
}

export enum LOCATION {
  EWALLET = 'EWallet',
  TRADING_PLATFORMS = 'TradingPlatforms',
  TRADING_ACCOUNTS = 'TradingAccounts',
  NOTIFICATIONS = 'Notifications',
}

export enum DEVICE_ENUM {
  MOBILE = 'Mobile',
  DESKTOP = 'Desktop',
}

export enum KYC_STATUS {
  IN_PROCESS = 'InProcess',
  APPROVED = 'Approved',
  DECLINED = 'Declined',
}

export enum SORT_TYPE {
  ASCENDING = 'Ascending',
  DESCENDING = 'Descending',
  DEFAULT = 'Default',
}

export enum PSP_OPERATION_PROMOTE_TYPE {
  COMMIT = 'Commit',
  APPROVE = 'Approve',
  REJECT = 'Reject',
  REFUND = 'Refund',
}

export enum ELEMENT_POSITION {
  LEFT = 'left',
  RIGHT = 'right',
}

export enum CLIENT_APP_TYPE {
  WEB_APP = 'WebApp',
  MOBILE_APP = 'MobileApp',
  ALL = 'All',
}

export enum KYT_VERIFICATION_STATUS {
  INITIATED = 'Initiated',
  INPROCESS = 'InProcess',
  FINISHED = 'Finished',
  ERROR = 'Error',
}

export enum KYT_VERIFICATION_API_LOG_TYPE {
  USER = 'User',
  TRANSFER = 'Transfer',
  WITHDRAWAL_ATTEMPT = 'WithdrawalAttempt',
}

export enum TRADING_ACCOUNT_FORM_TYPE {
  DEMO = 'Demo',
  SELF = 'Real',
  INVESTOR = 'Follower',
  MASTER = 'Master',
}

export enum TRADING_ACCOUNT_SOURCE {
  DEFAULT = 'Default',
  SIDEBAR = 'Sidebar',
}

export enum ACCOUNT_TYPE_PREFIX {
  STD = 'Standard',
  ECN = 'ECN',
  CENT = 'Cent',
}

export enum COPY_TYPE {
  EQUITY = 'Equity',
  BALANCE = 'Balance',
  LOT = 'Lot',
}

export enum QUERY_PARAMS {
  OPEN_ACCOUNT = 'openaccount',
  SOURCE = 'source',
  ACTION = 'action',
  COPY = 'copy',
  STOP = 'stop',
  MASTER = 'master',
  INVESTOR = 'investor',
  PLATFORM_TYPE = 'platform-type',
  CONTEST_ID = 'contest-id',
}

export enum MASTERS_RATING_ACTION_SOURCE {
  EXTERNAL = 'external',
  DEFAULT = 'default',
}

export enum OPERATION_PARAMS {
  GREATER_OR_EQUAL = 'GreaterOrEqual',
  LESS_OR_EQUAL = 'LessOrEqual',
  LIKE = 'Like',
  EQUAL = 'Equal',
  NOT_EQUAL = 'NotEqual',
  LESS = 'LESS',
  GREATER = 'Greater',
}

export enum LIST_APPEARANCE {
  GRID = 'grid',
  LIST = 'list',
}

export enum CHART_TYPE {
  AREA = 'area',
  PERCENT = 'percent',
}

export enum NOTIFICATION_TYPE {
  WARNING = 'warning',
  NOTICE = 'notice',
  DANGER = 'danger',
  PSP = 'psp',
}

export enum PSP_INFO_LOADING_STATUS {
  EMPTY = 'empty',
  LOADING = 'loading',
  LOADED_SUCCESS = 'loaded_success',
  LOADED_FAIL = 'loaded_fail',
}

export enum CAPTCHA_PROVIDERS {
  RECAPTCHA = 'recaptcha',
  HCAPTCHA = 'hcaptcha',
}

export enum MAM_LINK_STATUS {
  DRAFT = 'Draft',
  IN_PROGRESS = 'InProgress',
  DECLINED = 'Declined',
  APPROVED = 'Approved',
}

export enum MAM_ALLOCATION_MODE {
  LOT = 'Lot',
  EQUITY = 'Equity',
}

export enum REASSIGNMENT_TYPE {
  ALL_USERS = 'AllUsers',
  SPECIFIC_IB = 'SpecificIB',
}

export enum TRADING_BONUS_STATUS {
  NEW = 'New',
  ACTIVE = 'Active',
  INITIATED = 'Initiated',
  COMPLETED = 'Completed',
  EXPIRED = 'Expired',
}

export enum TRADING_GROUP_TYPE {
  PROFIT_SHARE = 'ProfitShare',
  PROFIT_SHARE_CONDITIONS = 'ProfitShareOnConditions',
  REBATE = 'Rebate',
  REBATE_ZERO = 'RebateZero',
  STANDARD = 'Standard',
  NO_PAYOUT = 'NoPayout',
  ZERO_REBATE_BY_IB_TREE = 'ZeroRebateByIbTree',
  ZERO_REBATE_BY_IB_SPECIFICATION = 'ZeroRebateByIbSpecification',
}

export enum PREAUTHORIZED_TYPE {
  BANK_ACCOUNT = 'BankAccount',
  DIGITAL_WALLET = 'DigitalWallet',
  CARD = 'Card',
}

export enum COMPONENT_CLASS_TAGS {
  RECURRING_JOB_REPORT = 'RecurringJobReport',
}

export enum SCREEN_SIZE {
  xs = parseInt(variables.xs, 10),
  sm = parseInt(variables.sm, 10),
  md = parseInt(variables.md, 10),
  lg = parseInt(variables.lg, 10),
  xl = parseInt(variables.xl, 10),
}

export enum WEB_APPLICATION_ACCESS_TYPE {
  USER = 'User',
  ADMIN = 'Admin',
}

export enum COUNTRY_ACCESS_TYPE {
  ALLOWED = 'Allowed',
  FORBIDDEN = 'Forbidden',
}
